import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=363d2e7e&"
import script from "./CollectionFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports